import { useSelector } from 'react-redux';
import { USD } from 'self-service-api/constants/CurrencyCodes';
import { defaultCurrencySelector } from '../selectors/CurrencySelectors';
import { countrySelector, isInUnitedStatesSelector } from '../selectors/CountrySelectors';
export const useCustomCurrencyUnit = currencyCode => {
  const defaultCurrencyCode = useSelector(defaultCurrencySelector);
  const isUnitedStates = useSelector(isInUnitedStatesSelector);
  const country = useSelector(countrySelector);
  const isOutsideUnitedStates = !!country && !isUnitedStates;

  switch (currencyCode) {
    case USD:
      if (isOutsideUnitedStates && currencyCode === defaultCurrencyCode) {
        return 'US$';
      }

      break;

    default:
  }

  return undefined;
};